export default "__VITE_ASSET__BUGglhK4__"